<template>
    <div class="mt-8 py-2">
        <div
            @click="$emit('closed')"
            class="btn btn-square btn-sm btn-ghost absolute top-0 right-0 m-1 close-z-100"
        >
            <span class="material-symbols-outlined notranslate fill-current">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                >
                    <path
                        d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
                    />
                </svg>
            </span>
        </div>
        <div class="mb-1 mx-4 flex justify-between">
            <div class="text-lg font-extrabold m-1 pb-2 mx-2">
                {{ trans.side_bar_navi.gallery }}
            </div>
        </div>

        <div class="overflow-y-auto pb-20 gallery-container">
            <div class="mx-4">
                <div class="mx-auto grid gap-3 grid-cols-2 sm\:grid-cols-2">
                    <img
                        v-for="(image, i) in images"
                        :key="i"
                        loading="lazy"
                        :src="image.url"
                        class="rounded-lg w-full h-full object-cover shadow-lg duration-300 hover-img"
                        @click="changeLocationDetail(image.index)"
                    />
                </div>
            </div>
            <div class="flex justify-center mt-4">
                <button
                    class="btn btn-primary"
                    @click="clickLoadMore"
                    v-if="images.length < imageList.length"
                >
                    もっと見る
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        trans: {
            type: Object,
            required: true,
        },
        locationResource: {
            type: Array,
            required: true,
        },
        isOnParcelMap: {
            type: Boolean,
            default: false,
        },
        currentLayer: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    data() {
        return {
            currentItem: 1,
            limitItem: 20,
            images: [],
        };
    },
    computed: {
        imageList() {
            let images = [];
            for (let index in this.locationResource) {
                let location = this.locationResource[index];
                for (let url of location.properties.images) {
                    images.push({
                        index: index,
                        url: url,
                        title: location.title,
                    });
                }
            }
            return images;
        },
    },
    methods: {
        changeLocationDetail(index) {
            let payload = this.locationResource[index];
            if (!payload) {
                return;
            }
            this.$emit("closed");
            this.$emit("changedLocationDetail", payload);
            this.$emit("isOpenedGalleryBox", true);
            if (
                this.isOnParcelMap &&
                payload.properties.layer_id &&
                !this.isOnCurrentLayer(payload.properties.layer_id)
            ) {
                this.$emit("changedLayerId", payload.properties.layer_id);
            }
        },
        isOnCurrentLayer(layerId) {
            return this.currentLayer && this.currentLayer.id == layerId;
        },
        clickLoadMore() {
            this.currentItem++;
            this.handleLoadMore();
        },
        handleLoadMore() {
            const start = (this.currentItem - 1) * this.limitItem;
            const end = start + this.limitItem;
            this.images = [
                ...this.images,
                ...this.randomImageList(this.imageList.slice(start, end)),
            ];
        },
        randomImageList(imageList) {
            for (let i = imageList.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [imageList[i], imageList[j]] = [imageList[j], imageList[i]];
            }
            return imageList;
        },
    },
    mounted() {
        setTimeout(() => {
            this.handleLoadMore();
        }, 2000);
    },
};
</script>

<style scoped>
.gallery-container {
    height: 95vh;
    padding-bottom: 14rem;
}
.hover-img:hover {
  transform: scale(1.04);
}
</style>
